import Qs from 'qs'
import omit from 'lodash/omit'

// 往url上添加参数，如果已存在参数则合并
export const addQueryToUrl = (url, params = {}, { decode } = { decode: false }) => {
    const decodeUrl = decode ? decodeURIComponent(url) : url

    const qIndex = decodeUrl.indexOf('?')

    if (qIndex === -1) {
        return `${decodeUrl}${Qs.stringify({ ...params }, { addQueryPrefix: true })}`
    } else {
        const path = decodeUrl.slice(0, qIndex)
        const query = decodeUrl.slice(qIndex + 1)
        const queryObj = query ? Qs.parse(query) : {}

        return `${path}${Qs.stringify({ ...queryObj, ...params }, { addQueryPrefix: true })}`
    }
}

// path 可能不包含domain
export function setParams(path, params, isOverwrite = false) {
    try {
        const hasOrigin = path.indexOf('http') === 0
        let url = hasOrigin ? path : location.origin + path
        const urlObj = new URL(url)
        Object.keys(params).forEach(key => {
            if (isOverwrite || (!isOverwrite && !urlObj.searchParams.has(key))) {
                urlObj.searchParams.set(key, params[key])
            }
        })
        return hasOrigin ? urlObj.href : urlObj.pathname + urlObj.search
    } catch (err) {
        console.error('catchError', err)
        return path
    }
}

// 清除url查询参数
export const clearUrlSearhParams = ({ omitKeys }) => {
    const urlObj = new URL(window.location.href)
    const { pathname, search, searchParams } = urlObj

    const isIn = omitKeys.some(v => searchParams.has(v))

    if (isIn) {
        const curQuery = Qs.parse(search, { ignoreQueryPrefix: true })

        const omitSearch = omit(curQuery, omitKeys)

        window.history.replaceState(null, '', `${pathname}${Qs.stringify(omitSearch, { addQueryPrefix: true })}`)
    }
}

// 安全多次解码
export const safeDecodeURIComponent = str => {
    try {
        let decoded = str
        while (/%[0-9A-Fa-f]{2}/.test(decoded)) {
            const next = decodeURIComponent(decoded)
            if (next === decoded) break
            decoded = next
        }
        return decoded
    } catch (e) {
        console.error('Decode error:', e.message)
        return str
    }
}
